import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "../lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success("Si l'email existe, un lien a été envoyé.");
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail));
    }
  };
  return (
    <div className="max-w-md mx-auto px-4 sm:px-6 py-16" data-testid="forgot-password-page">
      <h1 className="font-display font-bold text-3xl tracking-tight">Mot de passe oublié</h1>
      <p className="text-muted-foreground mt-2">Entrez votre email pour recevoir un lien de réinitialisation.</p>
      {!sent ? (
        <form onSubmit={submit} className="space-y-4 mt-8" data-testid="forgot-form">
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="votre@email.com" className="w-full px-4 py-3 border border-emerald-900/10 rounded-xl text-sm outline-none focus:border-primary" data-testid="forgot-email" />
          <button type="submit" className="btn-primary w-full justify-center" data-testid="forgot-submit">Envoyer le lien</button>
        </form>
      ) : (
        <div className="card-surface p-6 mt-6">
          <p className="text-sm">Si un compte existe pour <strong>{email}</strong>, vous recevrez un lien de réinitialisation.</p>
        </div>
      )}
      <Link to="/connexion" className="text-sm text-primary hover:underline mt-6 inline-block">← Retour à la connexion</Link>
    </div>
  );
}
